import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getSession, setSessionTitle, type AgentSession } from './api';

export const sessionKeys = {
  all: ['agent-sessions'] as const,
  one: (vertexSessionId: string) => [...sessionKeys.all, 'one', vertexSessionId] as const,
};

/**
 * The sreg-api row behind one sidebar card (by the thread's remote id = the
 * Vertex session id). Fetched per card so it follows assistant-ui's paging,
 * and refetched when a reply finishes (see RefreshSessionsOnRunEnd).
 */
export function useSessionRow(remoteId: string | undefined) {
  return useQuery({
    queryKey: sessionKeys.one(remoteId ?? ''),
    queryFn: ({ signal }) => getSession(remoteId!, signal),
    enabled: !!remoteId,
    // A brand-new conversation is registered with its first message; until
    // then sreg-api has no row, and that is not an error worth a banner.
    meta: { silent: true },
    retry: false,
  });
}

export function useSetSessionTitle() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ vertexSessionId, title }: { vertexSessionId: string; title: string }) =>
      setSessionTitle(vertexSessionId, title),
    onSuccess: (saved) => qc.setQueryData<AgentSession>(sessionKeys.one(saved.vertexSessionId), saved),
  });
}
